import { isRecord, isTimestamp } from "../types/data";
import type { DateValue } from "../types/data";

export const RATINGS_SYNC_VERSION = 1;
export interface RatingsSyncMetadata { revision?: number; version?: number; ratingsCount?: number | null; updatedAt?: DateValue; }

const toMillis = (value: unknown) => {
  if (!value) return 0;
  if (isRecord(value) && typeof value.toMillis === "function") return Number(value.toMillis());
  if (isTimestamp(value)) return value.toDate().getTime();
  if (isRecord(value) && Number.isFinite(Number(value.seconds))) {
    return (
      Number(value.seconds) * 1000 +
      Math.floor(Number(value.nanoseconds || 0) / 1000000)
    );
  }
  const parsed = value instanceof Date || typeof value === "string" || typeof value === "number" ? new Date(value).getTime() : NaN;
  return Number.isFinite(parsed) ? parsed : 0;
};

export const normalizeRatingsSyncMetadata = (userData: { ratingsSync?: RatingsSyncMetadata; publicStats?: { watchedFilms?: number; updatedAt?: DateValue } } | null = {}) => {
  const sync = userData?.ratingsSync || {};
  const revision = Number(sync.revision);
  const explicitCount = sync.ratingsCount == null
    ? null
    : Number(sync.ratingsCount);
  const publicCount = userData?.publicStats?.watchedFilms == null
    ? null
    : Number(userData.publicStats.watchedFilms);

  return {
    exists:
      Number(sync.version) >= RATINGS_SYNC_VERSION &&
      Number.isFinite(revision) &&
      revision > 0,
    version: Number(sync.version) || 0,
    revision: Number.isFinite(revision) && revision > 0 ? revision : 0,
    ratingsCount: explicitCount !== null && Number.isFinite(explicitCount)
      ? Math.max(0, explicitCount)
      : publicCount !== null && Number.isFinite(publicCount)
        ? Math.max(0, publicCount)
        : null,
    updatedAt: toMillis(sync.updatedAt || userData?.publicStats?.updatedAt)
  };
};
